<template>
    <div class="table-box">
        <div class="publicMain">
            <!-- 左边卡片 -->
            <el-card class="card-l" style="max-height: 775px" v-if="openPanel">
                <el-tree
                    accordion
                    :expand-on-click-node="true"
                    class="cardtree"
                    :data="dataTree"
                    :load="loadNode"
                    lazy
                    node-key="adcode"
                    @node-click="handleNodeClick"
                >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span>
                            <!-- <i class="party-icon" v-if="node.level < 4"></i> -->
                            <span class="tree-node-span">{{ data.name }}</span
                            ><i
                                v-if="data.level == 'district'"
                                class="el-icon-s-add"
                            ></i
                            ><i
                                v-if="node.level == 4"
                                class="el-icon-delete"
                                @click.stop="deletDataFuns(data.id)"
                            ></i>
                        </span>
                    </span>
                </el-tree>
            </el-card>
            <!-- 右边卡片 -->
            <div class="card-rb">
                <div class="card-4">
                    <el-card :body-style="{ padding: '16px' }">
                        <el-form
                            :model="formData"
                            size="small"
                            ref="formData"
                            class="demo-formData"
                            label-width="130px"
                        >
                            <el-row>
                                <el-col :span="11">
                                    <el-form-item
                                        label="请获取省："
                                        prop="shengId"
                                    >
                                        <el-select
                                            v-model="formData.shengId"
                                            ref="selectshengIdChange"
                                            placeholder="请获取省"
                                            disabled
                                            style="width: 80%"
                                        >
                                            <el-option
                                                v-for="(
                                                    item, index
                                                ) in provinceList"
                                                :key="index"
                                                :label="item.name"
                                                :value="item.adcode"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item
                                        label="请获取区："
                                        prop="quId"
                                    >
                                        <el-select
                                            v-model="formData.quId"
                                            ref="selectquIdChange"
                                            placeholder="请获取区"
                                            disabled
                                            style="width: 80%"
                                        >
                                            <el-option
                                                v-for="(
                                                    item, index
                                                ) in areaList"
                                                :key="index"
                                                :label="item.name"
                                                :value="item.adcode"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="11" :offset="2">
                                    <el-form-item
                                        label="请获取市："
                                        prop="shiId"
                                    >
                                        <el-select
                                            v-model="formData.shiId"
                                            ref="selectshiIdChange"
                                            placeholder="请获取市"
                                            disabled
                                            style="width: 80%"
                                        >
                                            <el-option
                                                v-for="(
                                                    item, index
                                                ) in cityList"
                                                :key="index"
                                                :label="item.name"
                                                :value="item.adcode"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item
                                        label="请输入街道："
                                        prop="addName"
                                    >
                                       <el-input v-model="formData.addName"
                                            placeholder="请输入街道"
                                            @change="jiedaochange"
                                           style="width: 80%"/>
                                        <!-- <el-select
                                            v-model="formData.jiedaoId"
                                            placeholder="请获取街道"

                                            ref="selectjiedaoIdChange"
                                            disabled
                                        >
                                            <el-option
                                                v-for="(
                                                    item, index
                                                ) in streetList"
                                                :key="index"
                                                :label="item.name"
                                                :value="item.adcode"
                                            >
                                            </el-option>
                                        </el-select> -->
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <!-- <el-form-item label="社区名称：" prop="address">
                                <el-input
                                    v-model.trim="formData.address"
                                    placeholder="请输入"
                                ></el-input>
                            </el-form-item> -->
                            <el-form-item label="区域定位：" prop="areaDivision">
                                <el-button
                                    type="danger"
                                    icon="el-icon-location-outline"
                                    @click="location"
                                    >定位到标准地址
                                </el-button>
                                <div class="box" style="margin-top: 25px">
                                    <mapbox
                                        v-if="mapshow"
                                        :orgId="formData"
                                        :on-success="mapSuccess"
                                        style="width: 100%; height: 500px"
                                    ></mapbox>
                                </div>
                            </el-form-item>
                            <el-form-item label='位置定位：' prop='address'>
                                <div class='posaddress'>
                                     <input
                                        v-model.trim="formData.address"
                                        id="tipinput"
                                        class="el-input__inner"
                                        @focus="getMap('tipinput')"
                                        placeholder="请输入关键字"
                                        autocomplete="off"
                                    />
                                    <i class="el-icon-location-information colorIcon" @click="chioceDizhi"></i>
                                </div>
                            </el-form-item>
                            <div
                                v-show='showmap'
                                    class="map_container"
                                    style="margin-bottom: 20px; overflow: hidden"
                                >
                                    <div
                                        id="addressMap"
                                        style="width: 100%; height: 250px"
                                    ></div>
                                </div>
                            <div class="footer">
                                <el-button
                                    type="primary"
                                    @click="submitFormSave('formData')"
                                    >保存
                                </el-button>
                                <el-button @click="cancleForm('formData')"
                                    >取消
                                </el-button>
                            </div>
                        </el-form>
                    </el-card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import mapbox from "./components/map"
import mapLoca from "./components/mapLoca"
import AMap from "AMap" // 引入高德地图
export default {
    name: "standardAddress",
    components: {
        mapbox,
        mapLoca,
    },
    data() {
        return {
            openPanel: true,
            // 树形控件的配置
            defaultProps: {
                children: "children",
                label: "label",
            },
            provinceList: [], //省列表
            cityList: [], //市列表
            streetList: [], //街道列表
            areaList: [], //区列表
            committeeList: [], //委员会
            communityList: [],
            showmap:false,
            formData: {
                id: "",
                address: "",
                parentId: "",
                shengId: "",
                quIdId: "",
                quId: "",
                jiedaoId: "",
                communityName: "",
                shiId: "",
                latitude: "",
                longitude: "",
                areaDivision: "",
                communityType: "",
                addName:"",
            },
            //地图显示
            myMap: null,
            marker: [],
            isMap: true,
            mapshow: false,
            lookdata: false,
            data5: [],
            dataTree: [],
            // admin: sessionStorage.getItem("admin"),
            mouseTool: null,
            isTree: true,
            treeRow: {},
            treeStyle: "",
            normalInfo: {},
            orgLevel: 0,
        }
    },
    created() {
        this.dataTree = []
        console.log("我的机构位置", this.$store.state.info)
        let roleIds = this.$store.state.info.roleIds.indexOf(1) == -1 ? 0 : 1
        this.treeStyle = this.$store.state.info.roleIds[0]

        if (roleIds == 1) {
            this.getProvince()
        } else {
            this.getOrg()
        }
    },
    mounted() {},

    methods: {
        // 获取机构
        getOrg() {
            this.$http
                .request({
                    url: "/rbac/admin/org/info/findOrgById",
                    method: "POST",
                    data: { id: this.$store.state.info.orgId },
                })
                .then((res) => {
                    if (res.code == 200) {
                        this.normalInfo = res.content
                    }
                })
        },
        chioceDizhi(){
           this.showmap= !this.showmap;
           console.log(this.formData.longitude)
            this.loadMap()
                 setTimeout(() => {
                    this.potintMap()
                }, 500)
        },
           //根据地址信息渲染标记点
        loadMap() {
            let self = this
            return new Promise((resolve, reject) => {
                self.myMap = new AMap.Map("addressMap", {
                    resizeEnable: true,
                    zoom: 18,
                })
                resolve()
            })
        },
        getMap(input) {
            const self = this
             console.log(self.formData.quId)
            const autoOptions = {
                city: self.formData.quId,
                citylimit: true,
                input: input,
            }
            // alert(input)
            const auto = new AMap.Autocomplete(autoOptions)
            //构造地点查询类
            AMap.event.addListener(auto, "select", (e) => {
                self.formData.address = e.poi.name
                self.formData.longitude = e.poi.location.lng
                self.formData.latitude = e.poi.location.lat
                // self.mapOff = false
                self.potintMap()
                self.$forceUpdate()
            })
        },
        // 打点
        potintMap() {
            console.log(this.formData.longitude,'00')
            const self = this
            // self.myMap.remove(self.marker);
            try {
                self.myMap.remove(self.marker)
            } catch (err) {
                console.log(err)
            }
            self.marker = new AMap.Marker({
                icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
                position: [
                    Number(this.formData.longitude),
                    Number(this.formData.latitude),
                ],
            })
            self.myMap.add(self.marker)
            self.myMap.setFitView()
            // if (self.dialogTitle == "新增") {
            self.mapCenter = [
                self.formData.longitude,
                self.formData.latitude,
            ]
        },
        // 保存
        submitFormSave(formName) {
            if (!this.formData.quId) {
                this.$message.error("请先选择地址")
                return
            }
            console.log(this.formData)
            this.formData.level='3'
            this.formData.parentId= this.formData.quId
            this.openPanel = false
            this.$http
                .request({
                    url: "/ypt/admin/addressYpe/info/save",
                    method: "POST",
                    data: this.formData,
                })
                .then((res) => {
                    console.log(res, "111")
                    if (res.code == 200) {
                        this.$message.success(res.message)
                        this.mapshow = false
                        this.showmap = false
                        this.dataTree = []
                        this.$refs[formName].resetFields()
                        this.openPanel = true
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        // 取消
        cancleForm(formName) {
            // this.formData={}
            this.$refs[formName].resetFields()
            this.mapshow = false
        },
        // 成功返回
        mapSuccess(info) {
            this.formData.areaDivision = info
            console.log(info, "地图信息")
        },
        // 地图显示
        location() {
            if (this.formData.shengId) {
                this.mapshow = !this.mapshow
                // this.joinAddress()
                // this.mapInit()
                console.log(this.formData, "提交数据")
            } else {
                this.$message.warning("请先选择地址")
            }
        },
        jiedaochange(){
            this.$forceUpdate()
        },
        //获取社区组织树形数据
        async handleNodeClick(data, node, resolve) {
            // console.log(data,"11")
            // console.log(node.level,"22");
            let lngLat = node.data.center
            if (lngLat) {
                this.formData.latitude = lngLat.lat
                this.formData.longitude = lngLat.lng
            }

            if (node.level == 1) {
                this.formData.shengId = node.data.adcode
                this.formData.shiId = ""
                this.formData.quId = ""
                this.formData.jiedaoId = ""
                this.formData.parentId = ""
                this.formData.address = ""
                this.formData.addName = ""
                this.formData.areaDivision = ""
            } else if (node.level == 2) {
                this.formData.shiId = node.data.adcode
                this.formData.quId = ""
                this.formData.jiedaoId = ""
                this.formData.parentId = ""
                this.formData.address = ""
                this.formData.addName = ""
                this.formData.areaDivision = ""
            } else if (node.level == 3) {
                this.formData.quId = node.data.adcode
                this.formData.parentId = ""
                this.formData.jiedaoId = ""
                this.formData.address = ""
                this.formData.addName = ""
                this.formData.areaDivision = ""
            } else if (node.level == 4) {
                console.log(data, "街道列表1")
                 this.mapshow = false
                this.formData.jiedaoId = data.addCode
                this.formData.parentId = data.addCode
                this.formData.addName = data.addName
                this.formData.address = data.address
                 this.showmap = false
                if (data.latitude && data.longitude) {
                    this.formData.latitude = data.latitude
                    this.formData.longitude = data.longitude
                }

                 this.formData.id = data.id
                this.formData.areaDivision = data.areaDivision
                     console.log(this.formData.areaDivision, "街道列表")
                this.$forceUpdate()
            } else if (node.level == 5) {
                console.log(data, "社区 空信息")
                this.mapshow = false
                if (data.latitude && data.longitude) {
                    this.formData.latitude = data.latitude
                    this.formData.longitude = data.longitude
                }
                this.formData.id = data.id
                this.formData.address = data.address
                this.formData.areaDivision = data.areaDivision
                // this.$forceUpdate()
            }
        },
        async loadNode(node, resolve) {
            let data2 = []
            let data1 =
                node.level === 4 || node.level === 5|| node.level === 3
                    ? []
                    : await this.getDistrict(node.data.adcode)

            if (this.treeStyle == 1) {
                if (node.level == 1) {
                    data2 = data1.districtList.map((item) => {
                        item.children = []
                        return item
                    })
                    this.cityList = data2
                    console.log(this.cityList, "城市")
                    resolve(data2)
                } else if (node.level == 2) {
                    data2 = data1.districtList.map((item, index) => {
                        item.children = []
                        item.adcode = item.adcode
                        return item
                    })
                    this.areaList = data2
                    console.log(this.areaList, "区")
                    resolve(data2)
                } else if (node.level == 3) {
                     this.$http
                        .request({
                            url: "/ypt/admin/addressYpe/info/findList",
                            method: "POST",
                            data: {
                                parentId: node.key,
                                pageNo:1,
                                pageSize:-1
                            },
                        })
                        .then((res) => {
                            if (res.code == 200) {
                                if (!res.content) {
                                    resolve([])
                                }
                               data2 = res.content.list.map((item) => {
                                    item.children = []
                                    item.name = item.addName
                                    item.adcode = item.addName
                                    return item
                                })
                                this.streetList = data2
                                resolve(data2)
                            } else {
                                resolve([])
                            }
                        })
                } else if (node.level == 4) {
                     resolve([])
                } else if (node.level == 5) {
                    resolve([])
                } else {
                    data2 = data1.districtList.map((item) => {
                        item.children = []
                        return item
                    })
                    resolve(data2)
                }
            } else {
                if (node.level == 0) {
                    if (this.normalInfo.provinceId) {
                        let dataProvice = []
                        data1.districtList.forEach((item, index) => {
                            if (item.adcode == this.normalInfo.provinceId) {
                                item.children = []
                                dataProvice.push(item)
                            }
                        })
                        this.provinceList = dataProvice

                        resolve(dataProvice)
                    } else {
                        resolve([])
                    }
                } else if (node.level == 1) {
                    if (this.normalInfo.provinceId && this.normalInfo.cityId) {
                        let dataCity = []
                        data1.districtList.forEach((item, index) => {
                            if (item.adcode == this.normalInfo.cityId) {
                                item.children = []
                                dataCity.push(item)
                            }
                            // return dataCity
                        })
                        this.cityList = dataCity
                        console.log("城市", this.cityList)
                        console.log("省份", this.provinceList)
                        resolve(dataCity)
                    } else {
                        if (
                            this.normalInfo.orgLevel == 1 &&
                            this.normalInfo.provinceId
                        ) {
                            let dataCity = []
                            data1.districtList.forEach((item, index) => {
                                item.children = []
                                dataCity.push(item)
                            })
                            this.cityList = dataCity
                            resolve(dataCity)
                        } else {
                            resolve([])
                        }
                    }
                } else if (node.level == 2) {
                    if (
                        this.normalInfo.provinceId &&
                        this.normalInfo.cityId &&
                        this.normalInfo.areaId
                    ) {
                        let dataArea = []
                        data1.districtList.forEach((item, index) => {
                            if (item.adcode == this.normalInfo.areaId) {
                                item.children = []
                                dataArea.push(item)
                            }
                        })
                        this.areaList = dataArea
                        resolve(dataArea)
                    } else {
                        if (
                            (this.normalInfo.provinceId &&
                                this.normalInfo.orgLevel == 2) ||
                            (this.normalInfo.provinceId &&
                                this.normalInfo.orgLevel == 1)
                        ) {
                            let dataArea = []
                            data1.districtList.forEach((item, index) => {
                                item.children = []
                                dataArea.push(item)
                            })
                            this.areaList = dataArea
                            resolve(dataArea)
                        } else {
                            resolve([])
                        }
                    }
                } else if (node.level == 3) {
                    if (
                        this.normalInfo.provinceId &&
                        this.normalInfo.cityId &&
                        this.normalInfo.areaId &&
                        this.normalInfo.streetId
                    ) {
                       this.$http
                        .request({
                            url: "/ypt/admin/addressYpe/info/findList",
                            method: "POST",
                            data: {
                                parentId: node.key,
                                pageNo:1,
                                pageSize:-1
                            },
                        })
                        .then((res) => {
                            if (res.code == 200) {
                                if (!res.content) {
                                    resolve([])
                                    return
                                }
                               data2 = res.content.list.map((item) => {
                                    if (item.addCode == this.normalInfo.streetId) {
                                            item.children = []
                                            item.addName = item.addName
                                            item.name= item.addName
                                            item.addCode = item.addCode
                                    }else{
                                         item.name = item.addName
                                    }
                                    return item
                                })
                                this.streetList = data2
                                console.log(this.streetList,'jiedao')
                                resolve(data2)
                            } else {
                                resolve([])
                            }
                        })
                    } else {
                        if (
                            (this.normalInfo.provinceId &&
                                this.normalInfo.orgLevel == 2) ||
                            (this.normalInfo.provinceId &&
                                this.normalInfo.orgLevel == 1) ||
                            (this.normalInfo.provinceId &&
                                this.normalInfo.orgLevel == 3)
                        ) {
                            // let dataStreet = []
                            // data1.districtList.forEach((item, index) => {
                            //     item.children = []
                            //     item.adcode = item.adcode + index
                            //     dataStreet.push(item)
                            // })
                            // this.streetList = dataStreet
                            this.$http
                                .request({
                                    url: "/ypt/admin/addressYpe/info/findList",
                                    method: "POST",
                                    data: {
                                        parentId: node.key,
                                        pageNo:1,
                                        pageSize:-1
                                    },
                                })
                                .then((res) => {
                                    if (res.code == 200) {
                                        if (!res.content) {
                                            resolve([])
                                            return
                                        }
                                    data2 = res.content.list.map((item) => {
                                           item.children = []
                                            item.addName = item.addName
                                            item.name=item.addName
                                            item.addCode = item.addCode
                                              return item
                                        })
                                        this.streetList = data2
                                        console.log(this.streetList,'jiedao1')
                                        resolve(data2)
                                    }
                                })
                                } else {
                                    resolve([])
                                }
                    }
                } else if (node.level == 4) {
                   resolve([])
                } else if (node.level == 5) {
                    resolve([])
                }
            }
        },
        //获取省级
        async getProvince() {
            this.provinceList = []
            this.cityList = []
            this.areaList = []
            this.streetList = []
            let province = await this.getDistrict()
            this.provinceList = province.districtList
        },

        // 添加树
        async addDataFun(parmar, node) {
            let self = this
            this.formData = {}
            let formData = {}
            this.mapshow = false
            if (parmar.communityType == 0) {
                formData.communityName = parmar.shi
                formData.communityType = 1
            } else if (parmar.communityType == 1) {
                formData.communityName = parmar.qu
                formData.communityType = 2
            } else if (parmar.communityType == 2) {
                formData.communityName = parmar.jiedao
                formData.communityType = 3
            } else {
                formData.communityName = parmar.shequ
                formData.communityType = 4
            }
            formData.parentId = parmar.id
            formData.address = parmar.address
            formData.shengId = parmar.shengId
            formData.sheng = parmar.sheng
            formData.quId = parmar.quId
            formData.qu = parmar.qu
            formData.jiedaoId = parmar.jiedaoId
            formData.jiedao = parmar.jiedao
            formData.shiId = parmar.shiId
            formData.shi = parmar.shi
            formData.latitude = parmar.latitude
            formData.longitude = parmar.longitude
            formData.areaDivision = parmar.areaDivision
            this.formData = Object.assign({}, formData)
        },
        // 获取树
        //获取地址
        getDistricts(name = "中国", params = null) {
            let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                    subdistrict: 1, //返回下一级行政区
                    extensions: "all",
                    showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                let geocoder = new AMap.Geocoder({
                    city: "", //城市设为北京，默认：“全国”
                    radius: 1000, //范围，默认：500
                })
                try {
                    self.myMap.remove(self.marker)
                } catch (err) {
                    console.log(err)
                }

                self.marker = new AMap.Marker()
                district.search(name, (status, result) => {
                    if (status == "complete") {
                        resolve(result.districtList[0])
                        if (this.isMap) {
                            this.isMap = false
                            return
                        }
                        let bounds = result.districtList[0].boundaries
                        self.polygon = null
                    }
                })
            }).catch((err) => {
                console.log(err)
            })
        },
        //删除树
        deletDataFuns(id) {
            let data = { id: id }
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.openPanel = false
                this.$http
                    .request({
                        url: "/ypt/admin/addressYpe/info/deleteById",
                        method: "POST",
                        data,
                    })
                    .then((res) => {
                        if (res.code === 200) {
                            this.mapshow = false
                            this.dataTree = []
                            this.formData = {}
                            this.openPanel = true
                        }
                    })
            })
        },
        //获取地址
        getDistrict(name = "中国", params = null) {
             let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                    subdistrict: 1, //返回下一级行政区
                    extensions: "all",
                    showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                let geocoder = new AMap.Geocoder({
                    city: "", //城市设为北京，默认：“全国”
                    radius: 1000, //范围，默认：500
                })
                try {
                    self.myMap.remove(self.marker)
                } catch (err) {
                    // console.log(err);
                }

                self.marker = new AMap.Marker()
                district.search(name, (status, result) => {
                    if (status == "complete") {
                        resolve(result.districtList[0])
                    }
                })
            }).catch((err) => {
                console.log(err)
            })
        },

        // 成功返回
        onSuccess(info) {
            this.formData.areaDivision = info
            console.log(info, "地图信息")
        },
        //  省级地址选择发生改变
        async handleProvince(val) {
            this.cityList = []
            this.areaList = []
            this.streetList = []
            this.communityList = []
            this.formData.shi = ""
            this.formData.qu = ""
            this.formData.jiedao = ""
            let city = await this.getDistrict(val)

            this.cityList = city.districtList
        },
        //市级地址发生改变
        async handleCity(val) {
            this.areaList = []
            this.streetList = []
            this.communityList = []
            this.formData.qu = ""
            this.formData.jiedao = ""
            let area = await this.getDistrict(val)
            console.log(area.districtList, "111")
            this.areaList = area.districtList
        },
        //县区级地址发生改变
        async handleArea(val) {
            this.streetList = []
            this.communityList = []
            this.formData.originalStreetId = ""
            this.formData.originalCommunityId = ""
            let street = await this.getDistrict(val)
            this.streetList = street.districtList
        },
        //街道地址发生变化
        streetChange(val) {
            this.streetList.forEach((item) => {
                if (item.adcode == val) {
                    this.formData.latitude = item.center.lat
                    this.formData.longitude = item.center.lng
                }
            })
        },
    },
}
</script>
<style lang='less' scoped>
.publicMain {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: calc(100% - 50px);

    .member-title {
        height: 30px;
        line-height: 30px;
    }

    /deep/ ::-webkit-scrollbar {
        display: block;
    }

    .el-form-item {
        margin-bottom: 25px !important;
    }

    .party-icon {
        display: inline-block;
        width: 16px;
        height: 15px;
        background-image: url("./assets/img/icon_011.png");
    }

    // 左边树状列表卡片
    .card-l {
        width: 260px !important;
        height: 100%;
        overflow-x: auto;
        overflow-y: auto;
        border: none;

        .cardtree {
            overflow-x: auto;
            width: 150%;

            .el-tree-node > .el-tree-node__children {
                overflow: auto;
                background-color: transparent;
            }

            /deep/ ::-webkit-scrollbar {
                display: block;
            }
        }
    }

    // 右边卡片
    .card-rb {
        width: calc(100% - 280px);
        height: 100%;
        overflow-y: auto;
        border: none;

        .card-4 {
            border: none;
            height: 100%;

            .demo-formData {
                .formData_box {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                    padding: 20px 0;

                    .formData_item {
                        width: 48%;

                        .rulelable {
                            width: 100%;
                            height: 35px;
                        }

                        .ruleinput {
                            width: 100%;
                            display: flex;
                            justify-content: space-between;

                            .rulespan2 {
                                float: left;
                                width: 49%;

                                .rulespan2_input {
                                    width: 100%;
                                }
                            }
                        }
                    }

                    .ruleradio {
                        height: 75px;
                        line-height: 75px;
                    }
                }

                .formData_bottom {
                    width: 100%;
                    text-align: right;
                    margin-top: 40px;
                }
            }
        }
    }

    .addressselect {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;

        .addressselect_item {
            width: 24%;
        }
    }

    .address_xx {
        width: 100%;
        height: 320px;
        display: flex;
        justify-content: space-between;

        .add_list {
            width: 24%;
            height: 300px;
            border: 1px solid #c0c6d9;
            border-radius: 5px;
            overflow-y: auto;
        }

        .add_map {
            width: 74%;
            height: 300px;
            border: 1px solid #c0c6d9;
        }
    }

    .custom-tree-node {
        position: relative;

        .el-icon-s-icon {
            content: url(./assets/img/icon_011.png);
            width: 15px;
            height: 15px;
            float: left;
            margin-top: 3px;
        }

        .tree-node-span {
            margin-left: 10px;
        }

        .el-icon-s-add {
            content: url(./assets/img/metro_05.png);
            width: 15px;
            margin-left: 10px;
        }

        .el-icon-s-add:hover {
            content: url(./assets/img/metro_03.png);
        }

        .el-icon-delete {
            content: url(./assets/img/metro_14.png);
            width: 15px;
            margin-left: 10px;
        }

        .el-icon-delete:hover {
            content: url(./assets/img/metro_13.png);
            // width: 12px;
            // height: 12px;
            // margin-left: 10px;
        }
    }

    .ZUZHIimg {
        position: relative;

        .threestyleimg {
            display: flex;
            flex-wrap: wrap;

            .threestyleimgtu {
                width: 100%;
                height: 70%;
                // background-color: red;
                display: flex;
                // justify-content: center;
                // align-items: center;
            }

            .threestyleimgbtnzzxz {
                input {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 463px;
                    height: 200px;
                    opacity: 0;
                    cursor: pointer;
                }
            }

            .el-icon-s-add {
                content: url(./assets/img/metro_05.png);
                width: 15px;
                margin-left: 10px;
            }

            .el-icon-s-add:hover {
                content: url(./assets/img/metro_03.png);
            }

            .el-icon-delete {
                content: url(./assets/img/metro_14.png);
                width: 15px;
                margin-left: 10px;
            }

            .el-icon-delete:hover {
                content: url(./assets/img/metro_13.png);
                // width: 12px;
                // height: 12px;
                // margin-left: 10px;
            }
        }

        .ZUZHIimg {
            position: relative;

            .threestyleimg {
                display: flex;
                flex-wrap: wrap;

                .threestyleimgtu {
                    width: 100%;
                    height: 70%;
                    // background-color: red;
                    display: flex;
                    // justify-content: center;
                    // align-items: center;
                }

                .threestyleimgbtnzzxz {
                    input {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 463px;
                        height: 200px;
                        opacity: 0;
                        cursor: pointer;
                    }
                }
            }
        }

        .el-form-item {
            margin-bottom: 0px;
        }
    }
}

.elder_manage_title {
    position: relative;
    width: 100%;
    margin-bottom: 15px;

    &::after {
        position: absolute;
        left: 120px;
        right: 0;
        display: block;
        content: "";
        border-bottom: 1px solid #e4e7ed;
    }

    .title {
        box-sizing: border-box;
        display: inline-block;
        width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #409eff;
        font-size: 14px;
        border: 1px solid #e4e7ed;
        border-bottom: none;
        border-radius: 4px 4px 0 0;
        box-sizing: border-box;
        background: #ffffff;
    }
}

.footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 15px;
}

#organizationMap {
    width: 100%;
    height: 470px;
}
.posaddress{
    position:relative;
    .colorIcon{
        color: #0000ff;
       font-size: 30px;
       position:absolute;
       right:10px;
       top:5px;
    }
}
</style>
